import { render } from "./DomainManagerForm.vue?vue&type=template&id=2cccf42c"
import script from "./DomainManagerForm.vue?vue&type=script&lang=js"
export * from "./DomainManagerForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/html/miw-alpha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__